import { NativeModule, requireNativeModule } from 'expo';

import type {
  NormalizePickedImageOptions,
  NormalizedImage,
} from './ImageOrientationNormalizer.types';

declare class ImageOrientationNormalizerModule extends NativeModule<Record<string, never>> {
  normalizePickedImage(options: NormalizePickedImageOptions): Promise<NormalizedImage>;
}

export default requireNativeModule<ImageOrientationNormalizerModule>('ImageOrientationNormalizer');
